import ScopeResolver from 'resolvers/RTMResolvers/ScopeResolver';

/**
 * Builds a service to access author and learner scope.
 */
export default (() => {
  /**
   * @type {ScopeResolver}
   */
  let scopeResolver;
  let isRegistered = false;

  /**
   * Get list of sources registered to a scope
 * @param {string} scopeURN
 * @param {string} elementId
 * @param {string} elementType
   */
  const getAuthorSourceScopeList = async (scopeURN, elementId, elementType) => {
    const scopeList = await scopeResolver.authorSourceScopeList({
      scopeURN,
      elementId,
      elementType,
    });
    return scopeList;
  };

  return {
    isRegistered: () => isRegistered,

    register: (connectionProvider) => {
      isRegistered = true;
      scopeResolver = new ScopeResolver(connectionProvider);
    },

    getAuthorSourceScopeList,
  };
})();
